import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Importer les fichiers de traduction
import enTranslation from './locales/en/translation.json';
import frTranslation from './locales/fr/translation.json';

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      fr: {
        translation: frTranslation, // Utiliser le fichier JSON
      },
      en: {
        translation: enTranslation, // Utiliser le fichier JSON
      },
    },
    fallbackLng: 'fr',
    detection: {
      order: ['navigator', 'localStorage', 'cookie'],
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false, // React gère déjà l'échappement XSS
    },
  });

export default i18next;